import React from 'react';
import Footer from '../Components/Footer';
import HeaderAbout from '../Components/HeaderAbout';
export default function About() {
  return <>
  <HeaderAbout/>
  <Footer/>
</>;
}
